import { iaRa } from 'lib/helpers/utility';

import { MEDICATION_STATUS } from './constants';

export const MEDICATION_PRESCRIBED_BY_ME_VIEW = 'prescribedByMe';

export const MEDICATION_SWITCH_ITEMS = [
  {
    label: 'Active',
    value: MEDICATION_STATUS.ACTIVE
  },
  {
    label: 'Inactive',
    value: MEDICATION_STATUS.INACTIVE
  }
];

const medicationSwitchValues = new Set(MEDICATION_SWITCH_ITEMS.map((item) => item.value));

export const getMedicationSwitchItems = ({ includePrescribedByMe = true } = {}) => {
  return [
    ...(includePrescribedByMe
      ? [
          {
            label: 'Prescribed by me',
            value: MEDICATION_PRESCRIBED_BY_ME_VIEW
          }
        ]
      : []),
    ...MEDICATION_SWITCH_ITEMS
  ];
};

const toComparableValue = (value) => {
  if (value == null || value === '') {
    return null;
  }

  return String(value);
};

const medicationStatusSortOrder = {
  [MEDICATION_STATUS.ACTIVE]: 0,
  [MEDICATION_STATUS.INACTIVE]: 1
};

export const getMedicationToggleItems = ({
  allLabel = 'All Medications',
  includePrescribedByMe = true
} = {}) => [
  {
    label: allLabel,
    value: null
  },
  ...getMedicationSwitchItems({ includePrescribedByMe })
];

export const isMedicationPrescribedByUser = (medication, user = {}) => {
  const internalUserIds = [user?.id, user?.user_id].map(toComparableValue).filter(Boolean);
  const veradigmUserId = toComparableValue(user?.veradigm_user_id);
  const medicationInternalAuthor = toComparableValue(medication?.created_by);
  const medicationExternalAuthors = [
    medication?.prescriber?.id,
    medication?.external_created_by,
    medication?.external_authorized_by
  ]
    .map(toComparableValue)
    .filter(Boolean);

  const hasInternalMatch = internalUserIds.some((userId) => userId === medicationInternalAuthor);
  const hasExternalMatch =
    !!veradigmUserId && medicationExternalAuthors.some((authorId) => authorId === veradigmUserId);

  return hasInternalMatch || hasExternalMatch;
};

const sortPrescribedMedications = (medications) => {
  return medications
    .map((medication, index) => ({
      medication,
      index
    }))
    .sort((leftMedication, rightMedication) => {
      const leftOrder = medicationStatusSortOrder[leftMedication?.medication?.status] ?? 99;
      const rightOrder = medicationStatusSortOrder[rightMedication?.medication?.status] ?? 99;

      if (leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
      }

      return leftMedication.index - rightMedication.index;
    })
    .map(({ medication }) => medication);
};

export const filterMedicationsByView = (medications, view, user = null) => {
  const medicationItems = iaRa(medications);

  if (view === MEDICATION_PRESCRIBED_BY_ME_VIEW) {
    return sortPrescribedMedications(
      medicationItems.filter((medication) => isMedicationPrescribedByUser(medication, user))
    );
  }

  if (!medicationSwitchValues.has(view)) {
    return medicationItems;
  }

  return medicationItems.filter((medication) => medication?.status === view);
};

export const getMedicationViewLabel = (view) => {
  if (view === MEDICATION_PRESCRIBED_BY_ME_VIEW) {
    return 'my prescribed';
  }

  if (view === MEDICATION_STATUS.ACTIVE) {
    return 'active';
  }

  if (view === MEDICATION_STATUS.INACTIVE) {
    return 'inactive';
  }

  return '';
};
